<template>
  <div>
    <!--   <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableObjectStorageDate"
      style="width: 100.1%"
    >
     <!--  <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button type="error" size="small" @click="tableDelmodal = true">{{
            $t("alarms.common.delete")
          }}</Button>
        </span>
        <Button type="info" size="small" @click="rowClick(row)">{{
          $t("alarms.common.details")
        }}</Button>
      </template> 
   </Table> -->
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableObjectStorageDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['monitor:objectStorageMonitor:delete']"
            @click="tableDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          v-hasPermission="['monitor:objectStorageMonitor:queryBucketByName']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="tableDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ autoscalingName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeAutoscaling()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableObjectStorageVue = {};
export default {
  name: "TableObjectStorage",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      tableDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      autoscalingName: "",
      columns: [
        {
          title: this.$t("alarms.common.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.objectStorage.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.objectStorage.objStoreName"),
          key: "name"
        },
        {
          title: this.$t("alarms.objectStorage.region"),
          key: "region"
        },
        {
          title: this.$t("alarms.objectStorage.creationDateString"),
          key: "creationDateString"
        },
        {
          title: this.$t("alarms.objectStorage.displayName"),
          key: "displayName"
        },
        // {
        //   title: this.$t("alarms.objectStorage.extranetEndpoint"),
        //   key: "extranetEndpoint"
        // },
        // {
        //   title: this.$t("alarms.objectStorage.intranetEndpoint"),
        //   key: "intranetEndpoint"
        // },
        // {
        //   title: this.$t("alarms.objectStorage.displayId"),
        //   key: "displayId"
        // },
        // {
        //   title: this.$t("alarms.objectStorage.access"),
        //   key: "access"
        // },
        {
          title: this.$t("alarms.objectStorage.defaultEncryption"),
          key: "defaultEncryption"
        },

        {
          title: this.$t("common.operation"),
          slot: "detail"
        }
      ],
      tableObjectStorageDate: []
    };
  },
  beforeCreate: function() {
    tableObjectStorageVue = this;
  },
  created() {
    eventBus.$on("locationSearchName", function(val) {
      tableObjectStorageVue.locationSearchName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableObjectStorageVue.companyId = val;
    });
    eventBus.$on("accountType", function(val) {
      tableObjectStorageVue.accountType = val;
    });
    eventBus.$on("accountName", function(val) {
      tableObjectStorageVue.accountName = val;
    });
  },
  mounted: function() {
    // tableObjectStorageVue.getObjectStorageData();
  },
  methods: {
    showAll: function() {
      tableObjectStorageVue.getObjectStorageData();
    },
    // 分页显示数据
    /****************************************************/
    getObjectStorageData: function() {
      //列表分页
      this.$api.bucket
        .pageBrokerSummary({
          bucketName: tableObjectStorageVue.locationSearchName,
          companyId: tableObjectStorageVue.companyId,
          accountType: tableObjectStorageVue.accountType,
          accountName: tableObjectStorageVue.accountName,
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 4
        })
        .then(res => {
          this.tableObjectStorageDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableObjectStorageVue.getObjectStorageData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableObjectStorageVue.getObjectStorageData();
    },
    // 销毁locationSearchName
    beforeDestroy: function() {
      eventBus.$off("locationSearchName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.autoscalingName = this.tableObjectStorageDate[index].accountName;
    },
    removeAutoscaling: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.bucket
        .deleteOss("id", this.tableObjectStorageDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableObjectStorageVue.getObjectStorageData();
            this.isDisable = false;
            this.modal_loading = false;
            this.tableDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/objectStorageDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          bucketName: row.name,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/object_storage/TableObjectStorage.vue